import Vue from 'vue'
import Router from 'vue-router'
import App from '@/App'
import { queryObj } from '@/utils/util'
import api from '../api'

const home = () => import('@/pages/home')
const homepage = () => import('@/pages/homepage')
const appointSuccess = () => import('@/pages/appointment-success')
const appointSuccess2 = () => import('@/pages/appointment-success2')
const appointSuccess3 = () => import('@/pages/appointment-success3')
const appointSuccess4 = () => import('@/pages/appointment-success4')
const appointSuccess5 = () => import('@/pages/appointment-success5')
const appointSuccess6 = () => import('@/pages/appointment-success6')
const appointSuccess7 = () => import('@/pages/appointment-success7')
const appointSuccess8 = () => import('@/pages/appointment-success8')
const appointSuccessXiaohongshu = () => import('@/pages/appointment-success-xiaohongshu')
const jinshujuDingzhiSuccess = () => import('@/pages/lp/jinshuju7-test/dingzhi-success')
const appointmentSuccess5Zhuanjieshao = () => import('@/pages/appointment-success5-zhuanjieshao')
const appointmentSuccess5ZhuanjieshaoA = () => import('@/pages/appointment-success5-zhuanjieshao-a')
const appointmentSuccess5ZhuanjieshaoB = () => import('@/pages/appointment-success5-zhuanjieshao-b')
const appointSuccessOversea = () => import('@/pages/appointment-success-oversea')
const zhifubaoSuccess = () => import('@/pages/zhifubao-success')
const information = () => import('@/pages/information')
const wxShare = () => import('@/pages/wx/share')
const sem = () => import('@/pages/lp/sem')
const semwxcopy = () => import('@/pages/lp/semwxcopy')
const sem2 = () => import('@/pages/lp/sem2')
const sem3 = () => import('@/pages/lp/sem3')
const sem7 = () => import('@/pages/lp/sem7')
const semTest = () => import('@/pages/lp/sem/test')
const dsp = () => import('@/pages/lp/dsp')
const test = () => import('@/pages/lp/dsp/test')
const feed = () => import('@/pages/lp/feed')
const xiaoxue = () => import('@/pages/lp/xiaoxue')
const chuzhong = () => import('@/pages/lp/chuzhong')
const zixun = () => import('@/pages/lp/zixun')
const offline = () => import('@/pages/lp/offline')
const gaozhong = () => import('@/pages/lp/gaozhong')
const nm = () => import('@/pages/lp/nm')
const nmcopy = () => import('@/pages/lp/nmcopy')
const nmwxcopy2 = () => import('@/pages/lp/nmwxcopy2')
const nm2 = () => import('@/pages/lp/nm')
const weixin = () => import('@/pages/lp/weixin')
const shequn = () => import('@/pages/lp/shequn')
const nmwx = () => import('@/pages/lp/nmwx')
const nmtest = () => import('@/pages/lp/nmtest')
const duihuan = () => import('@/pages/lp/duihuan/duihuan')
const baoming = () => import('@/pages/lp/duihuan/baoming')
const by = () => import('@/pages/lp/by')
const bd = () => import('@/pages/lp/bd')
const shengxue = () => import('@/pages/lp/shengxue')
const wxtg = () => import('@/pages/wxtg')
const primaryLesson = () => import('@/pages/primaryLesson')
// const double_activity = () => import('@/pages/lp/activity')
const math = () => import('@/pages/lp/math')
const componentNotFound = () => import('@/pages/404')
const greetCard = () => import('@/pages/greetCard')
const teacherDescrition = () => import('@/pages/parent/teacherDescrition')
const formalReport = () => import('@/pages/parent/formalReport')
const teacherDescritionParent = () => import('@/pages/parent/teacherDescritionParent')
const parentTeacherDescrition = () => import('@/pages/parent/evaluateReport')
const stuTeacherDescrition = () => import('@/pages/student/evaluateReport')
const parentCourseReport = () => import('@/pages/parent/courseReport')
const studentCourseReport = () => import('@/pages/student/courseReport')
const zxfdEvaluateReport = () => import('@/pages/zxfd/evaluateReport')
const zxfdCourseReport = () => import('@/pages/zxfd/courseReport')
const semYs = () => import('@/pages/lp/ys/sem')
const feedYs = () => import('@/pages/lp/ys/feed')
const zfbRed = () => import('@/pages/lp/zhifubao/zfb-red')
const zfbBlue = () => import('@/pages/lp/zhifubao/zfb-blue')
const sem8 = () => import('@/pages/lp/sem8')
const page100 = () => import('@/pages/lp/sem8/100')
const sem2Zixun2_12 = () => import('@/pages/lp/sem2-zixun2-12')
const semKemu = () => import('@/pages/lp/sem-kemu')
const dfx = () => import('@/pages/lp/esx-dfx/dfx')
const esx = () => import('@/pages/lp/esx-dfx/esx')
const esx2 = () => import('@/pages/lp/esx-dfx/esx2')
const esx3 = () => import('@/pages/lp/esx-dfx/esx3')
const esx3yzm = () => import('@/pages/lp/esx-dfx/esx3yzm')
const esx32 = () => import('@/pages/lp/esx-dfx/esx3-2')
const yk01 = () => import('@/pages/lp/esx-dfx/yk01')
const yk01exam = () => import('@/pages/lp/esx-dfx/yk01-exam')
const yk01xm = () => import('@/pages/lp/esx-dfx/yk01-xm')
const yk01xmyzm = () => import('@/pages/lp/esx-dfx/yk01-xm-yzm')
const yk01esx = () => import('@/pages/lp/esx-dfx/yk01-esx')
const yk01esxCg = () => import('@/pages/lp/esx-dfx/yk01-esx-cg')
const yk02 = () => import('@/pages/lp/esx-dfx/yk02')
const yk03 = () => import('@/pages/lp/esx-dfx/yk03')
const juhe = () => import('@/pages/lp/esx-dfx/juhe')
const juheXm = () => import('@/pages/lp/esx-dfx/juhe-xm')
const juhe01 = () => import('@/pages/lp/yk-esx/juhe01')
const xgs = () => import('@/pages/lp/esx-dfx/xgs')
const jinshujuGt = () => import('@/pages/lp/esx-dfx/jinshuju-gt')
const jinshujuArea = () => import('@/pages/lp/jinshuju-area')
const douyinAi = () => import('@/pages/lp/douyin')
const yk02Code = () => import('@/pages/lp/esx-dfx/yk02-code')
const yk02Senior = () => import('@/pages/lp/esx-dfx/yk02-senior')
const yk02Seniorcode = () => import('@/pages/lp/esx-dfx/yk02-seniorcode')
const PrimaryA = () => import('@/pages/lp/primary/primary-A')
const PrimaryB = () => import('@/pages/lp/primary/primary-B')


//家长端社区组件
const communitySection = () => import('@/pages/parent/community/communitySection')
const communityAnswerDetail = () => import('@/pages/parent/community/communityAnswerDetail')
const communityQuestionDetail = () => import('@/pages/parent/community/communityQuestionDetail')
const communityPerson = () => import('@/pages/parent/community/communityPerson')

//测评课报告 正式课报告 单页优化
const shareformalReport = () => import('@/pages/parent/report/formalReport')
// 测评课报告 分享
const shareEvaluateReport = () => import('@/pages/parent/report/evaluateReport')

// 测评课报告 分享
const measurementForm = () => import('@/pages/measurementForm')

const youkeIndex = () => import('@/pages/youke/index')
const youkeHome = () => import('@/pages/youke/home')
const semPoster = () => import('@/pages/lp/sem-poster')

// 家长端新增报名页
const wonderfulH5 = () => import('@/pages/parent/wonderfulH5')

// 报名落地页ab测试页面
const registerAB = () => import('@/pages/registerAB')

const wz001 = () => import('@/pages/wz/index')
const wz002 = () => import('@/pages/wz/two')
const wz003 = () => import('@/pages/wz/three')
const wzsuccess = () => import('@/pages/wz/success')

const littleJoy = () => import('@/pages/activity/littleJoy')

// 权益页面
const quanyi01 = () => import('@/pages/activity/quanyi/index')
const quanyi02 = () => import('@/pages/activity/quanyi/quanyi02')
const quanyi02plus = () => import('@/pages/activity/quanyi/quanyi02-plus')
const quanyi03 = () => import('@/pages/activity/quanyi/quanyi03')
const weikeSanxing = () => import('@/pages/activity/quanyi/weike-sanxing')
const quanyi04 = () => import('@/pages/activity/quanyi/quanyi04')
const quanyi05 = () => import('@/pages/activity/quanyi/quanyi05')
const quanyi04Grade = () => import('@/pages/activity/quanyi/quanyi04-grade')
const quanyiWechat = () => import('@/pages/activity/quanyi/quanyi-wechat')
const quanyiDuihuanma = () => import('@/pages/activity/quanyi/second')
const quanyiQueren = () => import('@/pages/activity/quanyi/second')
const quanyiSuccess02 = () => import('@/pages/activity/quanyi/success02')

const xwdsh = () => import('@/pages/lp/xwdsh')
const sem2sr = () => import('@/pages/lp/sem2sr')

const semPinpai = () => import('@/pages/lp/sem-pinpai')
const semJingpin = () => import('@/pages/lp/sem-jingpin')
const shanghai = () => import('@/pages/lp/shanghai/shanghai')
// const semPinpai = ()=> import('@/pages/lp/pinpai')
// const registerB = () => import('@/pages/registerB')

const dianshang = () => import('@/pages/lp/dianshang/dianshang')
const dianshangPay = () => import('@/pages/lp/dianshang/pay')
const jr = () => import('@/pages/lp/jr')

Vue.use(Router)

// const router = new Router
//export default new Router({

let statisticalGA = (next) => {
  window.dataLayer = window.dataLayer || [];
  function gtag () { dataLayer.push(arguments) }
  gtag('js', new Date());
  gtag('config', 'UA-85726094-1');
  console.log("dataLayer", dataLayer)
  next()
}

const Activity49 = {
  template: '<div></div>',
  beforeCreate () {
    let { channel_code, channel_keyword, gdt_vid } = this.$route.query
    channel_code = channel_code || ''
    channel_keyword = channel_keyword || ''
    gdt_vid = gdt_vid || ''
    let url;
    switch (process.env.NODE_ENV) {
      case 'development': url = 'https://buy.zmtest.net/introduce'; break;
      case 'uat': url = 'https://buy.zmtest.net/introduce'; break;
      case 'production': url = 'https://h5.abc-34.xyz/introduce'; break;
      default: url = 'https://buy.zmtest.net/introduce'; break;
    }

    window.location.replace(`${url}?channel_code=${channel_code}&channel_keyword=${channel_keyword}&gdt_vid=${gdt_vid}`)
  }
}
const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: App,
      children: [
        {
          path: '',
          name: 'home',
          component: home,
          beforeEnter: (to, from, next) => {
            setTimeout(() => {
              ZM_JSSDK && ZM_JSSDK.sendEvent({
                eventId: 'enter_1V1_homepage',
                eventParam: { userId: '' }
              })
            }, 0)
            next()
          }
        },
        {
          path: '/homepage',
          name: 'homepage',
          component: homepage,
          beforeEnter: (to, from, next) => {
            setTimeout(() => {
              ZM_JSSDK && ZM_JSSDK.sendEvent({
                eventId: 'enter_1V1_homepage',
                eventParam: { userId: '' }
              })
            }, 0)
            next()
          }
        },
        {
          path: '/oversea2',
          name: 'oversea2',
          component: () => import('@/pages/oversea/oversea2'),
          meta: {
            title: '掌门少儿'
          }
        },
        {
          path: '/2020sem7',
          name: '2020sem7',
          component: () => import('@/pages/oversea/2020sem7'),
          meta: {
            title: '掌门少儿'
          }
        },
        {
          path: 'tuiwen',
          name: 'tuiwen',
          component: home
        },
        {
          path: '/youke/',
          name: 'youke-index',
          component: youkeIndex
        },
        {
          path: '/youke/index',
          name: 'youke-home',
          component: youkeHome
        },
        {
          path: '/appointment-success',
          name: 'appointment-success',
          component: appointSuccess5,
        },
        {
          path: '/appointment-success2',
          name: 'appointment-success2',
          component: appointSuccess2,
        },
        {
          path: '/appointment-success4',
          name: 'appointment-success4',
          component: appointSuccess4,
        },
        {
          path: '/appointment-success5',
          name: 'appointment-success5',
          component: () => import('@/pages/appointment-success5-midd'),
        },
        {
          path: '/appointment-success6',
          name: 'appointment-success6',
          component: appointSuccess6,
        },
        {
          path: '/zhifubao-success',
          name: 'zhifubao-success',
          component: zhifubaoSuccess,
        },
        {
          path: '/appointment-success7',
          name: 'appointment-success7',
          component: appointSuccess7
        },
        {
          path: '/appointment-success8',
          name: 'appointment-success8',
          component: appointSuccess5,
        },
        {
          path: '/appointment-success-xiaohongshu',
          name: 'appointment-success-xiaohongshu',
          component: appointSuccessXiaohongshu,
        },
        {
          path: '/appointment-success-kid',
          name: 'appointment-success-kid',
          component: () => import("@/pages/appointment-success-kid")
        },
        {
          path: '/information-success',
          name: 'information-success',
          component: appointSuccess5,
        },
        {
          path: '/appointment-success5-a',
          name: 'appointment-success5-a',
          component: () => import("@/pages/appointment-success5-a"),
        },
        {
          path: '/appointment-success5-b',
          name: 'appointment-success5-b',
          component: () => import("@/pages/appointment-success5-b"),
        },
        {
          path: '/appointment-success5-c',
          name: 'appointment_success5_c',
          component: () => import("@/pages/appointment-success5-c"),
        },
        {
          path: '/appointment-success5-app',
          name: 'appointment-success5-app',
          component: () => import("@/pages/appointment-success5-app"),
        },
        {
          path: '/appointment-success-xtc',
          name: 'appointment-success-xtc',
          component: () => import("@/pages/appointment-success-xiaotiancai"),
        },
        {
          path: '/appointment-success-oversea',
          name: 'appointment-success-oversea',
          component: appointSuccessOversea,
          meta: {
            title: '掌门少儿'
          }
        },
        {
          path: '/lp/jinshuju-dingzhi-success',
          name: 'jinshuju-dingzhi-success',
          component: jinshujuDingzhiSuccess,
        },
        {
          path: '/information',
          name: 'information',
          component: information,
        },
        {
          path: '/wx/share',
          name: 'wx-share',
          component: wxShare,
        },
        {
          path: '/lp/sem',
          name: 'sem',
          component: sem,
        },
        {
          path: '/lp/semwxcopy',
          name: 'semwxcopy',
          component: semwxcopy,
        },
        {
          path: '/lp/sem2',
          name: 'sem2',
          component: sem2,
        },
        {
          path: '/lp/semab',
          name: 'semab',
          component: sem2,
        },
        {
          path: '/lp/sem3',
          name: 'sem3',
          component: sem3,
          beforeEnter (to, from, next) {
            const { _hmt } = window
            _hmt.push(['_trackPageview', '/lp/sem3']);
            next()
          }
        },
        {
          path: '/lp/sem7',
          name: 'sem7',
          component: sem7,
        },
        {
          path: '/lp/sem5',
          name: 'sem5',
          component: sem2,
        },
        {
          path: '/lp/sem/test',
          name: 'semTest',
          component: semTest,
        },
        {
          path: '/lp/sem2sr',
          name: 'sem2sr',
          component: sem2sr,
        },
        {
          path: '/lp/sem-pinpai',
          name: 'sem-pinpai',
          component: semPinpai,
        },
        {
          path: '/lp/sem-jingpin',
          name: 'sem-jingpin',
          component: semJingpin,
        },
        {
          path: '/lp/shanghai',
          name: 'shanghai',
          component: shanghai,
        },
        {
          path: '/lp/shanghai-junior',
          name: 'shanghai-junior',
          component: shanghai,
        },
        {
          path: '/lp/dianshang',
          name: 'dianshang',
          component: dianshang,
        },
        {
          path: '/lp/dianshang-pay',
          name: 'dianshang-pay',
          component: dianshangPay,
        },
        {
          path: '/lp/dsp',
          name: 'dsp',
          component: dsp,
        },
        {
          path: '/lp/dsp/test',
          name: 'test',
          component: test,
        },
        {
          path: '/lp/feed',
          name: 'feed',
          component: feed,
        },
        {
          path: '/lp/gz',
          name: 'gz',
          component: gaozhong,
          beforeEnter (to, from, next) {
            next()
          }
        },
        {

          path: '/lp/cz',
          name: 'cz',
          component: chuzhong,
          beforeEnter (to, from, next) {
            next()
          }
        },
        {
          path: '/lp/nm',
          name: 'nm',
          component: nm
        },
        {
          path: '/lp/nmmore',
          name: 'nmMore',
          component: nm
        },
        {
          path: '/lp/nmcopy',
          name: 'nmcopy',
          component: nmcopy
        },
        {
          path: '/lp/nmwxcopy2',
          name: 'nmwxcopy2',
          component: nmwxcopy2
        },
        {
          path: '/lp/weixin',
          name: 'weixin',
          component: weixin
        },
        {
          path: '/lp/shequn',
          name: 'shequn',
          component: shequn
        },
        {
          path: '/lp/zixun',
          name: 'zixun',
          component: zixun
        },
        {
          path: '/lp/offline',
          name: 'offline',
          component: offline
        },
        {
          path: '/lp/offline/market',
          name: 'offline-market',
          component: offline
        },
        {
          path: '/lp/offline/kebao',
          name: 'offline-kebao',
          component: offline
        },
        {
          path: '/lp/offline/addyouke',
          name: 'offline-addyouke',
          component: offline
        },
        {
          path: '/lp/zixun2',
          name: 'zixun2',
          component: () => import('@/pages/lp/zixun2')
        },
        {
          path: '/lp/junior',
          name: 'junior',
          component: nm2
        },
        {
          path: '/lp/young',
          name: 'young',
          beforeEnter (to, from, next) {
            if (/m.zhangmen.com/.test(window.location.origin)) {
              let url = 'https://m.zhangmenkid.com/?type=young';
              if (queryObj().ABTestUrl) {
                url += `&ABTestUrl=${queryObj().ABTestUrl}`
              }
              window.location.href = url
            } else {
              let url = 'https://m-test.zhangmenkid.com/?type=young';
              if (queryObj().ABTestUrl) {
                url += `&ABTestUrl=${queryObj().ABTestUrl}`
              }
              window.location.href = url
            }
            next()
          }
        },
        {
          path: '/lp/nmtest',
          name: 'nmtest',
          component: nmtest
        },
        {
          path: '/duihuan',
          name: 'duihuan',
          component: duihuan,
          meta: {
            title: '商品详情'
          }
        },
        {
          path: '/duihuan/baoming',
          name: 'baoming',
          component: baoming,
          meta: {
            title: '商品详情'
          }
        },
        {
          path: '/lp/cs',
          name: 'cs',
          component: nmwx
        },
        {
          path: '/home-weixin',
          name: 'wxtg',
          component: wxtg,
          beforeEnter: (to, from, next) => {
            setTimeout(() => {
              ZM_JSSDK && ZM_JSSDK.sendEvent({
                eventId: 'enter_1V1_homepage',
                eventParam: { userId: '' }
              })
            }, 0)
            next()
          }
        },
        {
          path: '/xiaoxue',
          name: 'xiaoxue',
          component: primaryLesson,
        },
        {
          path: '/lp/math',
          name: 'math',
          component: math
        },
        {
          path: '/lp/by',
          name: 'by',
          component: by
        },
        {
          path: '/lp/by-test',
          name: 'by-test',
          component: by
        },
        {
          path: '/lp/bd',
          name: 'bd',
          component: bd
        },
        {
          path: '/lp/shengxue',
          name: 'shengxue',
          component: shengxue
        },
        {
          path: '/greet-card',
          name: 'greet-card',
          component: greetCard
        },
        {
          path: '/parent/teacher-descrition',
          name: 'teacherDescrition',
          component: teacherDescrition
        },
        {
          path: '/parent/evaluate-report',
          name: 'parentTeacherDescrition',
          component: parentTeacherDescrition
        },
        {
          path: '/parent/course-report',
          name: 'parentCourseReport',
          component: parentCourseReport
        },
        {
          path: '/student/evaluate-report',
          name: 'stuTeacherDescrition',
          component: stuTeacherDescrition
        },
        {
          path: '/parent/teacher-descrition-parent',
          name: 'teacherDescritionParent',
          component: teacherDescritionParent
        },
        {
          path: '/student/course-report',
          name: 'studentCourseReport',
          component: studentCourseReport
        },
        {
          path: '/parent/formal-report',
          name: 'formalReport',
          component: formalReport
        },
        //子栏目详情
        {
          path: '/parent/community-section',
          name: 'communitySection',
          component: communitySection
        },
        {
          path: '/parent/community-answer-detail',
          name: 'communityAnswerDetail',
          component: communityAnswerDetail
        },
        {
          path: '/parent/community-question-detail',
          name: 'communityQuestionDetail',
          component: communityQuestionDetail
        },
        {
          path: '/parent/community-person',
          name: 'communityPerson',
          component: communityPerson
        },
        {
          path: '/zxfd/evaluate-report',
          name: 'zxfdEvaluateReport',
          component: zxfdEvaluateReport
        },
        {
          path: '/zxfd/course-report',
          name: 'zxfdCourseReport',
          component: zxfdCourseReport
        },
        //正式课报告优化
        {
          path: '/report/formal-report',
          name: 'shareformalReport',
          component: shareformalReport
        },
        {
          path: '/parent/share-evaluate-report', // 测评课报告分享
          name: 'share-evaluate-report',
          component: shareEvaluateReport
        },
        {
          path: '/lp/sem-poster1', //sem
          name: 'sem-poster1',
          component: semPoster,
          beforeEnter (to, from, next) {
            statisticalGA(next)
          }
        },
        {
          path: '/lp/sem-poster2', // 测评课报告分享
          name: 'sem-poster2',
          component: semPoster,
          beforeEnter (to, from, next) {
            statisticalGA(next)
          }
        },
        {
          path: '/lp/sem-poster3', // 测评课报告分享
          name: 'sem-poster3',
          component: semPoster,
          beforeEnter (to, from, next) {
            statisticalGA(next)
          }
        },
        {
          path: '/lp/sem-ys',
          name: 'semYs',
          component: semYs
        },
        {
          path: '/lp/feed-ys',
          name: 'feedYs',
          component: feedYs
        },
        {
          path: '/lp/sem2-ys',
          name: 'sem2-ys',
          component: () => import('@/pages/lp/ys/sem2-ys')
        },
        {
          path: '/lp/sem2-zixun2',
          name: 'sem2-zixun2',
          component: () => import('@/pages/lp/sem2-zixun2')
        },
        {
          path: '/lp/sem2-zixun3',
          name: 'sem2-zixun3',
          component: () => import('@/pages/lp/sem2-zixun3')
        },
        {
          path: '/lp/sem2-zixun4',
          name: 'sem2-zixun4',
          component: () => import('@/pages/lp/sem2-zixun4')
        },
        {
          path: '/lp/jinshuju-7-test2',
          name: 'jinshuju-7-test2',
          component: () => import('@/pages/lp/jinshuju7-test/test2')
        },
        {
          path: '/lp/jinshuju-wechat',
          name: 'jinshuju-wechat',
          component: () => import('@/pages/lp/jinshuju7-test/wechat')
        },
        {
          path: '/lp/jinshuju-7-test3',
          name: 'jinshuju-7-test3',
          component: () => import('@/pages/lp/jinshuju7-test/test3')
        },
        {
          path: '/lp/jinshuju-test3',
          name: 'jinshuju-test3',
          component: () => import('@/pages/lp/jinshuju7-test/new-test3')
        },
        {
          path: '/lp/jinshuju-test4-3',
          name: 'jinshuju-test4-3',
          component: () => import('@/pages/lp/jinshuju7-test/new-test3')
        },
        {
          path: '/lp/jinshuju-7-test4',
          name: 'jinshuju-7-test4',
          component: () => import('@/pages/lp/jinshuju7-test/new-test3')
        },
        {
          path: '/lp/jinshuju-test7',
          name: 'jinshuju-test7',
          component: () => import('@/pages/lp/jinshuju7-test/test7')
        },
        {
          path: '/lp/jinshuju-7-test',
          name: 'jinshuju-7-test',
          component: () => import('@/pages/lp/jinshuju7-test/new-test3')
        },
        {
          path: '/lp/jinshuju-test3-zhejiang',
          name: 'jinshuju-test3-zhejiang',
          component: () => import('@/pages/lp/jinshuju7-test/new-test3-zhejiang')
        },
        {
          path: '/lp/jinshuju-test4-2',
          name: 'jinshuju-test4-2',
          component: () => import('@/pages/lp/jinshuju7-test/new-test4-2')
        },
        {
          path: '/lp/jinshuju-dingzhi',
          name: 'jinshuju-dingzhi',
          component: () => import('@/pages/lp/jinshuju7-test/new-test3')
        },
        {
          path: '/lp/jinshuju-shujia',
          name: 'jinshuju-shujia',
          component: () => import('@/pages/lp/jinshuju7-test/shujia')
        },
        {
          path: '/lp/jinshuju-shanghai2',
          name: 'jinshuju-shanghai2',
          component: () => import('@/pages/lp/jinshuju7-test/shanghai2')
        },
        {
          path: '/lp/jinshuju-7-success',
          name: 'jinshuju-7-success',
          component: appointSuccess5
        },
        {
          path: '/lp/jinshuju-zhejiang',
          name: 'jinshuju-zhejiang',
          component: jinshujuArea
        },
        {
          path: '/lp/jinshuju-jiangsu',
          name: 'jinshuju-jiangsu',
          component: jinshujuArea
        },
        {
          path: '/lp/jinshuju-guangdong',
          name: 'jinshuju-guangdong',
          component: jinshujuArea
        },
        {
          path: '/lp/jinshuju-shanghai',
          name: 'jinshuju-shanghai',
          component: jinshujuArea
        },
        {
          path: '/lp/jinshuju-beijing',
          name: 'jinshuju-beijing',
          component: jinshujuArea
        },
        {
          path: '/weike',
          name: 'weike',
          component: () => import('@/pages/lp/weike')
        },
        {
          path: '/testzhifubao',
          name: 'test-zhifubao',
          component: home
        },
        {
          path: '/lp/zfb-red',
          name: 'zfb-red',
          component: zfbRed
        },
        {
          path: '/lp/zfb-blue',
          name: 'zfb-blue',
          component: zfbBlue
        },
        {
          path: '/lp/sem8',
          name: 'sem8',
          component: sem8
        },
        {
          path: '/lp/100',
          name: 'page100',
          component: page100
        },
        {
          path: '/lp/sem2-zixun2-1',
          name: 'sem2-zixun2-1',
          component: sem2Zixun2_12
        },
        {
          path: '/lp/sem2-zixun2-2',
          name: 'sem2-zixun2-2',
          component: sem2Zixun2_12
        },
        {
          path: '/lp/sem2-zixun2-cpa1',
          name: 'sem2-zixun2-cpa1',
          component: sem2Zixun2_12
        },
        {
          path: '/lp/sem2-zixun2-cpa2',
          name: 'sem2-zixun2-cpa2',
          component: sem2Zixun2_12
        },
        {
          path: '/lp/sem-kemu',
          name: 'sem-kemu',
          component: semKemu
        },
        {
          path: '/lp/dfx',
          name: 'dfx',
          component: dfx
        },
        {
          path: '/lp/esx',
          name: 'esx',
          component: esx
        },
        {
          path: '/lp/esx2',
          name: 'esx2',
          component: esx2
        },
        {
          path: '/lp/esx3',
          name: 'esx3',
          component: esx3
        },
        {
          path: '/lp/esx3-1',
          name: 'esx3-1',
          component: esx3
        },
        {
          path: '/lp/esx3-1-yk',
          name: 'esx3-1-yk',
          component: esx3
        },
        {
          path: '/lp/esx3yzm',
          name: 'esx3yzm',
          component: esx3yzm
        },
        {
          path: '/lp/esx3-2',
          name: 'esx3-2',
          component: esx32
        },
        {
          path: '/lp/esx3-2-yk',
          name: 'esx3-2-yk',
          component: esx32
        },
        {
          path: '/lp/yk01',
          name: 'yk01',
          component: yk01
        },
        {
          path: '/lp/yk01-exam',
          name: 'yk01-exam',
          component: yk01exam
        },
        {
          path: '/lp/yk01-xm',
          name: 'yk01-xm',
          component: yk01xm
        },
        {
          path: '/lp/yk01-xm-yzm',
          name: 'yk01-xm-yzm',
          component: yk01xmyzm
        },
        {
          path: '/lp/yk01-cg',
          name: 'yk01-cg',
          component: yk01xm
        },
        {
          path: '/lp/yk01-esx',
          name: 'yk01-esx',
          component: yk01esx
        },
        {
          path: '/lp/yk01-esx-cg',
          name: 'yk01-esx-cg',
          component: yk01esxCg
        },
        {
          path: '/lp/yk02',
          name: 'yk02',
          component: yk02
        },
        {
          path: '/lp/juhe',
          name: 'juhe',
          component: juhe
        },
        {
          path: '/lp/juhe-xm',
          name: 'juhe-xm',
          component: juheXm
        },
        {
          path: '/lp/juhe01',
          name: 'juhe01',
          component: juhe01
        },
        {
          path: '/lp/yk03',
          name: 'yk03',
          component: yk03
        },
        {
          path: '/lp/xgs',
          name: 'xgs',
          component: xgs
        },
        {
          path: '/lp/douyin-ai',
          name: 'douyin-ai',
          component: douyinAi
        },
        {
          path: '/lp/yk02-code',
          name: 'yk02-code',
          component: yk02Code
        },
        {
          path: '/lp/yk02-senior',
          name: 'yk02-senior',
          component: yk02Senior
        },
        {
          path: '/lp/yk02-seniorcode',
          name: 'yk02-seniorcode',
          component: yk02Seniorcode
        },
        {
          path: '/lp/Primary-A',
          name: 'Primary-A',
          component: PrimaryA
        },
        {
          path: '/lp/Primary-B',
          name: 'Primary-B',
          component: PrimaryB
        },
        {
          path: '/lp/jinshuju-gt',
          name: 'jinshuju-gt',
          component: jinshujuGt
        },
        {
          path: '/lp/jr',
          name: 'jr',
          component: jr
        },
        {
          path: '/lp/weike-sanxing',
          name: 'weike-sanxing',
          component: weikeSanxing
        },
        {
          path: '/lp/:id', // 测评课报告分享
          name: 'measurementForm',
          component: measurementForm,
          beforeEnter (to, from, next) {
            console.log(to, from)
            let id = to.params.id.substr(9, to.params.id.length)
            if (id === '6' || id === '7' || id === '8' || id === '9' || id === '10' || id === '19') {
              statisticalGA(next)
            } else {
              next()
            }
          }
        },
        {
          path: '/registerAB', // 报名页AB测试
          name: 'registerAB',
          component: registerAB,
          beforeEnter: (to, from, next) => {
            setTimeout(() => {
              ZM_JSSDK && ZM_JSSDK.sendEvent({
                eventId: 'enter_1V1_homepage',
                eventParam: { userId: '' }
              })
            }, 0)
            next()
          }
        },
        {
          path: '/parent/wonderfulH5',
          name: 'wonderfulH5',
          component: wonderfulH5
        },
        {
          path: '/wz01',
          name: 'wz001',
          component: wz001
        }, {
          path: '/wz02',
          name: 'wz002',
          component: wz002
        }, {
          path: '/wz03',
          name: 'wz003',
          component: wz003
        },
        {
          path: '/wz-success',
          name: 'wzsuccess',
          component: wzsuccess
        },
        {
          path: '/appointment-success5-zhuanjieshao-a',
          name: 'appointment-success5-zhuanjieshao-a',
          component: appointmentSuccess5ZhuanjieshaoA
        },
        {
          path: '/appointment-success5-zhuanjieshao-b',
          name: 'appointment-success5-zhuanjieshao-b',
          component: appointmentSuccess5ZhuanjieshaoB
        },
        {
          path: '/appointment-success5-zhuanjieshao',
          name: 'appointment-success5-zhuanjieshao',
          component: appointmentSuccess5Zhuanjieshao
        },
        {
          path: '/dear-home-land',
          name: 'dear-home-land',
          component: () => import("./../pages/activity/guoqingActivity"),
        },
        {
          path: '/m-activity-a',
          name: 'm-activity-a',
          component: () => import("@/pages/activity/mActivity/pageB"),
          beforeEnter: (to, from, next) => {
            setTimeout(() => {
              ZM_JSSDK && ZM_JSSDK.sendEvent({
                eventId: 'enter_1V1_homepage',
                eventParam: { userId: '' }
              })
            }, 0)
            next()
          }
        },
        {
          path: '/m-activity-b',
          name: 'm-activity-b',
          component: () => import("@/pages/activity/mActivity/pageC"),
          beforeEnter: (to, from, next) => {
            setTimeout(() => {
              ZM_JSSDK && ZM_JSSDK.sendEvent({
                eventId: 'enter_1V1_homepage',
                eventParam: { userId: '' }
              })
            }, 0)
            next()
          }
        },
        {
          path: '/m-activity02-a',
          name: 'm-activity02-a',
          component: () => import("@/pages/activity/mActivity02/pageB"),
          beforeEnter: (to, from, next) => {
            setTimeout(() => {
              ZM_JSSDK && ZM_JSSDK.sendEvent({
                eventId: 'enter_1V1_homepage',
                eventParam: { userId: '' }
              })
            }, 0)
            next()
          }
        },
        {
          path: '/m-activity02-b',
          name: 'm-activity02-b',
          component: () => import("@/pages/activity/mActivity02/pageC"),
          beforeEnter: (to, from, next) => {
            setTimeout(() => {
              ZM_JSSDK && ZM_JSSDK.sendEvent({
                eventId: 'enter_1V1_homepage',
                eventParam: { userId: '' }
              })
            }, 0)
            next()
          }
        },
        {
          path: '/xwdsh',
          name: 'xwdsh',
          component: xwdsh
        },
        {
          path: '/little-joy',
          name: 'little-joy',
          component: littleJoy
        },
        {
          path: '/quanyi01',
          name: 'quanyi01',
          component: quanyi02
        },
        {
          path: '/quanyi02',
          name: 'quanyi02',
          component: quanyi02
        },
        {
          path: '/quanyi02-plus',
          name: 'quanyi02-plus',
          component: quanyi02plus
        },
        {
          path: '/quanyi03',
          name: 'quanyi03',
          component: quanyi03
        },
        {
          path: '/quanyi03-ty',
          name: 'quanyi03-ty',
          component: quanyi03
        },
        {
          path: '/quanyi03-sanxing',
          name: 'quanyi03-sanxing',
          component: quanyi03
        },
        {
          path: '/quanyi03-edx',
          name: 'quanyi03-edx',
          component: quanyi03
        },
        {
          path: '/quanyi-wechat',
          name: 'quanyi-wechat',
          component: quanyiWechat
        },
        {
          path: '/quanyi04',
          name: 'quanyi04',
          component: quanyi04
        },
        {
          path: '/quanyi05',
          name: 'quanyi05',
          component: quanyi05
        },
        {
          path: '/quanyi04-grade',
          name: 'quanyi04-grade',
          component: quanyi04Grade
        },
        {
          path: '/quanyi01/duihuanma',
          name: 'quanyi-duihuanma',
          component: quanyiDuihuanma
        },
        {
          path: '/quanyi01/queren',
          name: 'quanyi-queren',
          component: quanyiQueren
        },
        {
          path: '/quanyi02/success',
          name: 'quanyi-success-02',
          component: quanyiSuccess02
        }
      ]
    },
    {
      path: '/AB/*',
      name: 'ab_jump',
    },
    {
      path: '/AB',
      name: "ab_jump_home"
    },
    {
      path: '/49-activity',
      name: "49-activity",
      component: Activity49
    },
    {
      path: '*',
      component: componentNotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  // 主动触发百度埋点事件
  // 链接或刷新进入时不触发主动触发百度埋点事件
  if (from.name) {
    const { _hmt } = window
    _hmt && _hmt.push(['_trackPageview', to.path]);
  }

  // 活动过期跳转开始
  // 如果不是当前有效期的活动，跳转到活动过期页面, 正则内容需改成最新的活动地址
  // 固定活动地址为 m-activity-a，m-activity-b, m-activity02-a, m-activity02-b
  const routePath = to.path.toLowerCase()
  const pathList = [
    {
      // 活动1
      path: ['/m-activity02-a', '/m-activity02-b'],
      start: new Date('2021/6/30 23:59:59'), // 开始时间小一点，允许活动开始前使用
      end: new Date('2021/7/31 23:59:59'),
      redirectTo: '/m-activity-a', // 活动过期后跳转
      isActive () {
        const now = new Date()
        return this.start <= now && now < this.end
      }
    },
    {
      // 活动2
      path: ['/m-activity-a', '/m-activity-b'],
      start: new Date('2021/9/1 23:59:59'), // 开始时间小一点，允许活动开始前使用
      end: new Date('2021/9/30 23:59:59'),
      redirectTo: '/m-activity02-a',
      isActive () {
        const now = new Date()
        return this.start <= now && now < this.end
      }
    }
  ]
  // 根据路由中是否包含activity字符串判断是否是活动页面，处理以往过期活动地址被用户收藏后访问情况
  if (routePath.indexOf('activity') != -1) {
    let excludePathStr = pathList.map(e => e.path).toString()
    if (excludePathStr.indexOf(routePath) != -1) {
      let currentItem = pathList.find(e => e.path.includes(routePath))
      if (currentItem && !currentItem.isActive()) {
        if (pathList.find(e => e.path.includes(currentItem.redirectTo)).isActive()) {
          // 如果当前活动过期了跳转到最新活动
          next({
            path: currentItem.redirectTo
          })
        } else {
          // 如果所有的活动页都过期了回到首页
          next({
            path: "/"
          })
        }
      }
    } else {
      // 如果访问已经过期的页面跳转到活动页
      next({
        path: '/m-activity02-a'
      })
      // window.location.href = ' https://m.zm-27.top/404?type=expired&comeFrom=' + to.path.replace('/', '')
    }
  }
  // 活动过期跳转结束

  // 创意360链接替换channek_keyword
  if (to.query.channel_code && to.query.channel_keyword
    && (to.query.channel_code == '10003' || to.query.channel_code == '10026' || to.query.channel_code == '10028' || to.query.channel_code == '10030')
    && !to.query.handelKeyword) {
    let newQuery
    newQuery = to.query
    api.getChannelKeyWord({ channelCode: to.query.channel_code, creativeId: to.query.channel_keyword }).then(
      res => {
        if (res.data.code == '0000') {
          newQuery.channel_keyword = res.data.data.channelKeyWord
          newQuery.handelKeyword = 1
          next({ path: to.path, query: newQuery })
        } else {
          next()
        }
      }
    ).catch(
      next()
    )
  } else {
    next()
  }
})
export default router

